import Vue from 'vue'

export function getItem(item) {
  if (window.localStorage) {
    try {
      return JSON.parse(localStorage.getItem(item)) || null
    } catch (e) {
      return JSON.parse(sessionStorage.getItem(item)) || null
    }
  } else {
    return JSON.parse(sessionStorage.getItem(item)) || null
  }
}

export function setItem(item, value) {
  value = JSON.stringify(value)
  if (window.localStorage) {
    try {
      localStorage.setItem(item, value)
    } catch (e) {
      sessionStorage.setItem(item, value)
    }
  } else {
    sessionStorage.setItem(item, value)
  }
}

export function installLangMixin() {
  let currentLang = getItem('currentLang') || 'cn'
  const EventBus = new Vue()
  Vue.mixin({
    data() {
      return {
        currentLang: currentLang,
        isPC: window.innerWidth < 990 ? false : true
      }
    },
    beforeDestroy() {
      EventBus.$off('languageChanged', this.onLanguageChanged)
    },
    created() {
      EventBus.$on('languageChanged', this.onLanguageChanged)
    },
    methods: {
      changeLang(lang) {
        EventBus.$emit('languageChanged', lang)
      },
      onLanguageChanged(lang) {
        if (currentLang !== lang) {
          currentLang = lang
          setItem('currentLang', lang)
          this.currentLang = lang
        }
      }
    }
  })
}
